<template>
  <div class="product-config">
    <CardInfo
      ref="cardInfoRef"
      :data="formData"
      v-on="$listeners"
      v-bind="$attrs"
    />
    <RentPlan :planIds="formData.planIds" ref="rentPlanRef" />
  </div>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue'
import { cloneDeep } from 'lodash'
import CardInfo from './components/CarInfo/index.vue'
import RentPlan from './components/RentPlan/index.vue'
import { useFormValidation } from './hooks/useFormValidation'
import { useEditFormState } from './hooks/useEditFormState'

const { validate: validateForm } = useFormValidation()
const { updateFields } = useEditFormState()

const props = defineProps({
  baseInfoVO: {
    type: Object,
    default: () => ({}),
  },
})

const cardInfoRef = ref(null)
const rentPlanRef = ref(null)
const formData = ref({})

// 监听商品id变化
watch(
  () => props.baseInfoVO,
  (n, o) => {
    if (n === o || !n) return
    updateFields({
      modelId: n.modelId,
      cityCode: n.cityCode,
    })
    nextTick(() => {
      formData.value = cloneDeep(n)
    })
  },
  {
    immediate: true,
  },
)

const validate = () => {
  const validateTasks = [
    { ref: cardInfoRef, name: 'cardInfo' },
    { ref: rentPlanRef, name: 'rentPlan' },
  ]
  return validateForm(validateTasks)
}

const preStoreValidate = async () => {
  return cardInfoRef.value.preStoreValidate()
}

defineExpose({
  validate,
  preStoreValidate,
  getData: () => {
    return {
      ...cardInfoRef.value.getData(),
      planIds: rentPlanRef.value.getData(),
    }
  },
})
</script>
